import React from "react";
import Card from "components/card";
import Chart from "react-apexcharts";

const CrawlerPromotePieChart = ({ promoteTrue, promoteFalse }) => {
  const total = promoteTrue + promoteFalse;
  if (total === 0) {
    return (
      <Card extra="p-5">
        <h4 className="text-base font-bold text-navy-700 dark:text-white mb-4 font-dm">
          Promotion Status
        </h4>
        <div className="flex items-center justify-center h-64">
          <p className="text-gray-500 dark:text-gray-400 text-sm">No data available</p>
        </div>
      </Card>
    );
  }

  const truePercent = ((promoteTrue / total) * 100).toFixed(1);
  const falsePercent = ((promoteFalse / total) * 100).toFixed(1);

  return (
    <Card extra="p-5">
      <h4 className="text-base font-bold text-navy-700 dark:text-white mb-1 font-dm">
        Promotion Status
      </h4>
      <p className="text-xs text-gray-500 dark:text-gray-400 mb-4 font-dm">
        {total} retailers scanned
      </p>
      <div className="flex items-center justify-center" style={{ minHeight: 260 }}>
        <Chart
          type="donut"
          width="100%"
          height={260}
          series={[promoteTrue, promoteFalse]}
          options={{
            labels: ["Promoted", "Not Promoted"],
            colors: ["#8b5cf6", "#f59e0b"],
            chart: {
              type: "donut",
              width: "100%",
              height: 260,
              fontFamily: "DM Sans, sans-serif",
            },
            plotOptions: {
              pie: {
                donut: {
                  size: "60%",
                  labels: {
                    show: true,
                    total: {
                      show: true,
                      label: "Total",
                      formatter: () => total,
                    },
                  },
                },
              },
            },
            legend: {
              position: "bottom",
              fontFamily: "DM Sans, sans-serif",
              fontSize: "12px",
            },
            dataLabels: {
              enabled: true,
              formatter: (val) => val.toFixed(1) + "%",
              style: { fontSize: "11px", fontFamily: "DM Sans, sans-serif" },
            },
            tooltip: {
              enabled: true,
              theme: "dark",
              y: {
                formatter: (value, { seriesIndex }) => {
                  const pct = seriesIndex === 0 ? truePercent : falsePercent;
                  return `${value} (${pct}%)`;
                },
              },
            },
            stroke: { width: 2 },
            states: {
              hover: { filter: { type: "darken", value: 0.9 } },
              active: { filter: { type: "none" } },
            },
          }}
        />
      </div>
    </Card>
  );
};

export default CrawlerPromotePieChart;
